import axios from 'axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000',
  withCredentials: true, // CORS Cookie送信に必須（CloudFront移行後も維持）
  headers: {
    'Content-type': 'application/json',
    Accept: 'application/json',
  },
})

// TEMPORARY: CloudFront移行後に削除 (Token認証 → Cookie認証に戻す)
// Add token to all requests
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default client
